import React from 'react'
import styled from '@emotion/styled'

import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'
import {cssTheme} from '@vio/atlas/themes'

import {OfferLayoutBaseProps, OfferLayoutLoadingProps} from '.'

const Wrapper = styled.div`
  padding: ${cssTheme.layout.spacing.s300} ${cssTheme.layout.spacing.s400};
`

const ContentWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
`

const SkeletonWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: ${cssTheme.layout.spacing.s200};
`

type Props = Pick<
  OfferLayoutBaseProps,
  | 'isLoading'
  | 'priceComponent'
  | 'providerLogoComponent'
  | 'ctaComponent'
  | 'yourChoiceComponent'
  | 'dataId'
  | 'cashbackComponent'
>

export const SecondaryWithoutRoomNameLayout: React.FC<
  Props | OfferLayoutLoadingProps
> = ({
  isLoading,
  priceComponent,
  providerLogoComponent,
  ctaComponent,
  yourChoiceComponent,
  dataId,
  cashbackComponent
}) => {
  if (isLoading)
    return (
      <Wrapper>
        <SkeletonWrapper>
          <SkeletonLoader width={40} marginTop={0} />
        </SkeletonWrapper>
        <SkeletonLoader width={48} />
      </Wrapper>
    )

  return (
    <Wrapper data-id={dataId}>
      {providerLogoComponent}
      <ContentWrapper>
        {priceComponent}
        {ctaComponent}
      </ContentWrapper>
      {cashbackComponent}
      {yourChoiceComponent}
    </Wrapper>
  )
}
